import { Message } from 'element-ui';
/**
 * @description 将数据字典数据映射为{label: 'xx', value: 'xx'}形式
 * @param {Object} dictData 字典数据
 * @returns {Array} [{ label: 'xx', value: 'xx' }, { label: 'xx', value: 'xx' }]
 */
export const formatDictDataToLabelValue = dictData => {
    return Object.entries(dictData).map(v => ({ label: v[1], value: v[0] }));
};

/**
 * @description 整车异常发车原因登记校验
 */
export const isValidate = data => {
    if (Array.isArray(data)) {
        if (!data.length) {
            Message.warning('请选择发车单');
            return false;
        }
        for (const item of data) {
            if (!validate(item)) return false;
        }
        // 是否在始发地围栏全部 不为否时，弹出提示，不可登记
        const isFence = data.filter(data => data.beginLandRail === '0');
        if (!isFence.length) {
            Message.warning('是否在始发地围栏为否时才可登记');
            return false;
        }
        return true;
    } else {
        if (!validate(data)) return false;
        if (data.beginLandRail !== '0') {
            Message.warning('是否在始发地围栏为否时才可登记');
            return false;
        }
        return true;
    }
};

/**
 * @description 选择数据中发运类型存在非整车、发车状态存在未发车，则弹出提示，不可登记
 */
const validate = data => {
    if (data.shippingType !== '00') {
        Message.warning('发运类型为整车才可登记');
        return false;
    }
    // 数据字典待确认
    if (![30, 40, 50, 60, 70, 80].includes(+data.etdoStatus)) {
        Message.warning('发车后才可登记');
        return false;
    }
    return true;
};
